import { useState } from 'react';

import { ContentResponse, ReportHeaderResponse } from '../../report.types';

const useReportTablePaginationBase = () => {
  const [page, setPage] = useState(0);
  const [rawContentList, setRawContentList] = useState<ContentResponse[]>([]);

  const [rawHeaders, setRawHeaders] = useState<ReportHeaderResponse[]>([]);


  return {
    page,
    setPage,
    rawContentList,
    setRawContentList,
    rawHeaders,
    setRawHeaders,
  };
};

export default useReportTablePaginationBase;
